import { useT } from '../lib/i18n';
import React from 'react';
import type { AssignmentType } from '@/services/learningService';

const CLS: Record<AssignmentType, string> = {
  required: 'bg-red-100 text-red-700 dark:bg-red-500/[0.16] dark:text-red-300',
  recommended: 'bg-blue-100 text-blue-700 dark:bg-blue-500/[0.16] dark:text-blue-300',
  optional: 'bg-muted text-muted-foreground',
};

/** Required / Recommended / Optional pill. */
export const AssignmentTypeBadge: React.FC<{ type?: AssignmentType | null; className?: string }> = ({ type, className }) => {
  const t = useT();
  if (!type) return null;
  const label = {
    required: t('training:required', 'Required'),
    recommended: t('training:recommended', 'Recommended'),
    optional: t('training:optional', 'Optional'),
  }[type] || type;
  return (
    <span data-testid="assignment-type-badge" className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${CLS[type] || CLS.optional} ${className || ''}`}>
      {label}
    </span>
  );
};

export default AssignmentTypeBadge;
